var metaCustomJs = document.querySelector('meta[name="custom-js"]');
let isSwiper     = false;

if (metaCustomJs != null) {
  if (metaCustomJs.getAttribute('custom-js') == 'true') {
    isSwiper = true;
  }
}

const Swiper = (
  await import(`${isSwiper ? `https://ga.jspm.io/npm:swiper@10.0.0/swiper.mjs` : `swiper`}`)
).default
await import(`${isSwiper ? `https://ga.jspm.io/npm:swiper@10.0.0/swiper-bundle.mjs` : `swiper/bundle`}`)

document.querySelectorAll('.swiper-galery').forEach(el => {
  const swipeIndex = el.closest('.image-galery').querySelector('.swipe-index')
  const swipEl = new Swiper(el, {
    direction: 'horizontal',
    loop: true,
    speed: 1000,
    autoplay: false,
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
    }
  })

  swipEl.on('slideChange', () => {
    if (swipeIndex) {
      swipeIndex.textContent = swipEl.activeIndex + 1
    }
  })
})

document.querySelectorAll('[data-galery]').forEach(el => {
  el.addEventListener('click', () => {
    let galery = document.querySelector(el.getAttribute('data-galery'))
    galery.classList.add('active')
  })
})
//
document.querySelectorAll('.image-galery').forEach(el => {
  el.querySelectorAll('.close').forEach(close => {
    close.addEventListener('click', () => {
      el.closest('.image-galery').classList.remove('active')
    })
  })
  // Escape
  document.addEventListener('keydown', e => {
    // ESCAPE key pressed
    if (e.keyCode == 27) {
      el.closest('.image-galery').classList.remove('active')
    }
  })
})

document.querySelectorAll('[data-slider]').forEach(el => {
  const jsonConfig = JSON.parse(el.dataset.config || '{}')
  new Swiper(el, {
    direction: 'horizontal',
    loop: el.dataset.loop === 'true',
    speed: parseFloat(el.dataset.speed),
    autoplay: el.dataset.autoPlay === 'true' && {
      delay: parseFloat(el.dataset.autoPlayDelay),
    },
    pagination: {
      clickable: true,
      el: el.querySelector('.slider-pagination'),
    },
    ...jsonConfig,
  })
})
